
import { get_driving,get_address } from "../api/gaode/index"


//https://restapi.amap.com/v3/direction/driving
//?origin=116.481028,39.989643&destination=116.465302,40.004717&extensions=all&output=xml
//&key=<用户的key>

var default_params = new Object();

default_params.key = GD_KEY;
default_params.strategy = 11;

//经度：103.843336, 纬度：31.68022, 高程：1562.68 
//经度：103.837812, 纬度：31.674299, 高程：1553.29 
export function driving(params, callback) {
    default_params.origin = "103.0530006548997,30.327451457154336"
    default_params.destination = "102.99480724705518,30.336909022472895"
    default_params.show_fields="polyline,cost,traffic_lights,duration"
    get_driving(default_params).then(res => {
        console.log(res);
        callback(res);
    }).catch(e => {
        console.error(e)
    });

}


export function drivingSearch(params, callback) {
    //default_params.origin = "103.843336,31.68022"
    //default_params.destination = "103.837812,31.674299"
    params.key = GD_KEY;
    //params.strategy = 32; //strategy
    params.show_fields="polyline"
    // params.avoidpolygons=`
    // 102.99782679735506,30.321135331481855;
    // 102.9918499682912,30.32510883148177;
    // 102.99090946829136,30.31914633148176;
    // 102.9880744682913,30.315726331481756;
    // 102.98958646829135,30.315753331481858;
    // 102.98955046829121,30.315438331481914;
    // 102.99334396829119,30.32117583148181;
    // 102.99771796829106,30.32108583148181
    // `
    get_driving(params).then(res => {
        console.log(res);
        callback(res);
    }).catch(e => {
        console.error(e)
    });

}


export function addressSearch(params, callback) {
    params.key = GD_KEY;
    get_address(params).then(res => {
        console.log(res);
        callback(res);
    }).catch(e => {
        console.error(e)
    });

}